export function toFiniteNumbers(values: (number | string)[]): number[] {
  return values.map(Number).filter(Number.isFinite);
}
